export const SOCKET_NAMESPACE = '/chat';
/** Комната чата. Обе стороны состоят в ней вне зависимости от инстанса. */
export function chatRoom(chatId) {
    return `chat:${chatId}`;
}
/** Личная комната пользователя: доставка событий во все его вкладки. */
export function userRoom(userId) {
    return `user:${userId}`;
}
// ─── Клиент → сервер ─────────────────────────────────────────────────────────
export const ClientEvent = {
    JOIN_QUEUE: 'join_queue',
    CANCEL_QUEUE: 'cancel_queue',
    TYPING: 'typing',
    MESSAGE: 'message',
    MEDIA: 'media',
    READ: 'read',
    REPORT: 'report',
    LEAVE_CHAT: 'leave_chat',
    NEXT_CHAT: 'next_chat',
    FRIEND_REQUEST: 'friend_request',
    FRIEND_RESPOND: 'friend_respond',
};
// ─── Сервер → клиент ─────────────────────────────────────────────────────────
export const ServerEvent = {
    MATCH_FOUND: 'match_found',
    MESSAGE: 'message',
    MEDIA: 'media',
    TYPING: 'typing',
    READ: 'read',
    USER_LEFT: 'user_left',
    CHAT_CLOSED: 'chat_closed',
    QUEUE_POSITION: 'queue_position',
    QUEUE_LEFT: 'queue_left',
    PARTNER_STATUS: 'partner_status',
    FRIEND_REQUESTED: 'friend_requested',
    FRIEND_ACCEPTED: 'friend_accepted',
    FRIEND_DECLINED: 'friend_declined',
    /** Ответить согласием не вышло: эти двое уже друзья. */
    FRIEND_ALREADY: 'friend_already',
    FRIEND_REMOVED: 'friend_removed',
    ERROR: 'error',
};
//# sourceMappingURL=events.js.map